import { motion } from 'framer-motion'

const GRADIENT_STYLE = {
  background: 'linear-gradient(90deg, #000 0%, #AF231C 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
} as const

interface AnimatedHeadingProps {
  children: string
  size?: 'default' | 'small' | 'large'
  className?: string
}

const AnimatedHeading = ({ children, size = 'default', className = '' }: AnimatedHeadingProps) => (
  <motion.h2
    initial={{ opacity: 0, y: -15 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5, delay: 0.1, ease: 'easeOut' }}
    style={GRADIENT_STYLE}
    className={`${
      size === 'default'
        ? 'font-bold !text-[32px] sm:!text-[36px] leading-[38px] sm:leading-[52px] tracking-[-0.2px]'
        : size === 'large'
        ? 'font-bold !text-[36px] sm:!text-[40px] leading-[40px] sm:leading-[58px] tracking-[-0.5px]'
        : 'font-semibold !text-[32px] leading-[38px] tracking-[-0.5px]'
    } ${className}`}>
    {children}
  </motion.h2>
)

export default AnimatedHeading
